(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('present-list', {
            parent: 'entity',
            url: '/present-list?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.presentList.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/present-list/present-lists.html',
                    controller: 'PresentListController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('presentList');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('present-list-detail', {
            parent: 'entity',
            url: '/present-list/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.presentList.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/present-list/present-list-detail.html',
                    controller: 'PresentListDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('presentList');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PresentList', function($stateParams, PresentList) {
                    return PresentList.get({id : $stateParams.id});
                }]
            }
        })
        .state('present-list.new', {
            parent: 'present-list',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/present-list/present-list-dialog.html',
                    controller: 'PresentListDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                description: null,
                                selectable: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('present-list', null, { reload: true });
                }, function() {
                    $state.go('present-list');
                });
            }]
        })
        .state('present-list.edit', {
            parent: 'present-list',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/present-list/present-list-dialog.html',
                    controller: 'PresentListDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PresentList', function(PresentList) {
                            return PresentList.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('present-list', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('present-list.delete', {
            parent: 'present-list',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/present-list/present-list-delete-dialog.html',
                    controller: 'PresentListDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PresentList', function(PresentList) {
                            return PresentList.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('present-list', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
